<template>
	<div class="container" :class="{ 'no-heading-image': !page.headingImage, subpage: page.slug !== 'index' }">
		<Html :lang="locale" translate="no" />
		<Head v-if="page">
			<Title>{{ page.metaTitle }}</Title>
			<Meta name="description" :content="page.metaDescription" />
			<Meta name="robots" :content="page.metaRobots" />
			<Meta name="google" content="notranslate" />
			<Hreflangs v-if="page.slug !== '404'" :langmenu="page.langmenu" />
		</Head>

		<navigation />

		<slot />

		<review-slider v-if="page.showReviewSlider" :header="defaults[locale].website.reviewsHeader" />

		<pre-footer v-if="page && page.footerSection.length" :footer-section="page.footerSection[0]" />

		<newsletter
			v-if="page && page.showNewsletter"
			:header="defaults[locale].newsletter.title"
			:content="defaults[locale].newsletter.content"
			:button="defaults[locale].newsletter.button"
		/>

		<breadcrumbs
			v-if="page && page.slug != 'index'"
			:breadcrumbs="page.breadcrumbs"
			:home="defaults[locale].website.hotelName"
		/>

		<footers />

		<pop-up
			v-if="page && defaults[locale].popUp.content"
			:image="defaults[locale].popUp.image"
			:content="defaults[locale].popUp.content"
		/>
		<cookie-consent v-if="defaults[locale].cookieConsent.published" :item="defaults[locale].cookieConsent" />
		<to-top />
	</div>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { locale } = useI18n();
const config = useRuntimeConfig();
const route = useRoute();
const { defaults, fetchDefaults } = useDefaults();

if (!defaults.value) {
	await fetchDefaults();
}

await fetchPage();

const handleScroll = () => {
	const fixedElements = document.querySelectorAll('.fix-on-scroll');
	if (window.pageYOffset >= 50) {
		fixedElements.forEach((el) => el.classList.add('fixed'));
	} else {
		fixedElements.forEach((el) => el.classList.remove('fixed'));
	}
};

watch(
	() => route.path,
	async () => {
		await fetchPage();
	},
	{ immediate: false },
);

onBeforeMount(() => {
	window.addEventListener('scroll', handleScroll);
});

onBeforeUnmount(() => {
	window.removeEventListener('scroll', handleScroll);
});

const currentUrl = config.public.siteUrl + route.fullPath;
const { website } = defaults.value[locale.value];
const { metaDescription, metaTitle } = page.value;

if (import.meta.server) {
	useSeoMeta({
		twitterCard: metaDescription || '',
		twitterSite: currentUrl || '',
		twitterTitle: metaTitle || '',
		twitterDescription: metaDescription || '',
		twitterCreator: website.hotelName || '',
		twitterImage: website.structuredImage || '',
		ogTitle: metaTitle || '',
		ogUrl: currentUrl || '',
		ogImage: website.structuredImage || '',
		ogDescription: metaDescription || '',
		ogSiteName: website.hotelName || '',
	});

	useHead({
		script: [
			{
				type: 'application/ld+json',
				innerHTML: JSON.stringify({
					'@context': 'http://schema.org',
					'@type': 'Hotel',
					'@id': `${config.public.siteUrl}#hotel`,
					image: website.structuredImage,
					url: config.public.siteUrl,
					name: website.hotelName,
					logo: `${config.public.siteUrl}/images/logo-hotel-herbergh-white-full.png`,
					telephone: website.phone,
					email: website.email,
					address: {
						'@type': 'PostalAddress',
						streetAddress: `${website.street} ${website.number}, ${website.city}`,
						postalCode: website.postalCode,
					},
				}),
			},
		],
	});
}
</script>
